
import ActiveUserMixin from '@/mixins/activeUserMixin'
import { defineComponent, PropType } from 'vue'

import { AccessTokenExpirationStatus } from '~/types/types'
import { formatDate, getDateDiffInDays, parseISODate } from '~/utils/date'
import BaseCard from '../History/BaseCard.vue'

export default defineComponent({
  name: 'PersonalAccessTokenCard',
  mixins: [ActiveUserMixin],
  components: {
    BaseCard
  },
  meta: {
    auth: {
      strict: true,
      redirectToLogin: true
    }
  },

  props: {
    id: {
      type: String
    },
    description: {
      type: String
    },
    expiresAt: {
      type: String,
      default: ''
    },
    lastUsedAt: {
      type: String,
      default: ''
    },
    expirationStatus: {
      type: String as PropType<
        | AccessTokenExpirationStatus.Active
        | AccessTokenExpirationStatus.Expired
        | AccessTokenExpirationStatus.DoesNotExpire
      >
    }
  },

  computed: {
    expiry(): string {
      return formatDate(parseISODate(this.expiresAt), 'll')
    },

    expiryDiff(): number {
      return getDateDiffInDays(this.expiresAt, String(new Date(Date.now())), true)
    },

    parsedlastUsedAt(): string {
      return formatDate(parseISODate(this.lastUsedAt), 'll')
    }
  }
})
